import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExportRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 15 15",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.527 2.549H2.922a.38.38 0 0 0-.373.38v9.141c0 .21.168.381.373.381h5.955a.38.38 0 0 0 .372-.38v-1.143h1.117v1.142c0 .84-.668 1.524-1.489 1.524H2.922c-.822 0-1.49-.683-1.49-1.524V2.93c0-.84.668-1.524 1.49-1.524h3.105c.396 0 .775.16 1.054.445l2.85 2.919c.279.285.435.673.435 1.078v1.654H9.249V6.36H7.202c-.926 0-1.675-.767-1.675-1.714zm1.675 6.094h4.98l-.72-.738a.58.58 0 0 1 0-.807.55.55 0 0 1 .788 0l1.675 1.714a.58.58 0 0 1 0 .807l-1.675 1.713a.547.547 0 0 1-.789 0 .58.58 0 0 1 0-.807l.722-.737H7.202a.564.564 0 0 1-.558-.572c0-.316.249-.571.558-.571zm1.584-3.428L6.644 3.023v1.62c0 .317.249.572.558.572z" })
});
export default SvgExportRegularIcon;
